import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d9fc80a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-fields" }
const _hoisted_2 = {
  key: 0,
  class: "text-error text-caption mt-1"
}
const _hoisted_3 = {
  key: 0,
  class: "text-error text-caption mt-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.show,
    persistent: "",
    "max-width": "500"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-h6" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.title), 1)
            ]),
            _: 1
          }),
          (_ctx.isEdit && _ctx.hasSentOffers)
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 0,
                type: "warning",
                variant: "tonal",
                class: "mx-4 mb-2 flex-shrink-0",
                density: "compact"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" A dátum, a helység, a létszám, az elhelyezés vagy az ellátás módosítása érvényteleníti a már megkapott ajánlatokat. ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.area,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.area) = $event)),
                  label: "Helység",
                  variant: "outlined",
                  rules: [_ctx.rules.required]
                }, null, 8, ["modelValue", "rules"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: _ctx.selectedCostCenter,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedCostCenter) = $event)),
                  items: _ctx.costCenters,
                  "item-title": "name",
                  "item-value": "id",
                  label: "Költséghely",
                  variant: "outlined",
                  rules: [_ctx.rules.required]
                }, null, 8, ["modelValue", "items", "rules"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_Datepicker, {
                  modelValue: _ctx.from,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.from) = $event)),
                  placeholder: "Érkezés",
                  "enable-time-picker": false,
                  format: 'yyyy-MM-dd',
                  "auto-apply": ""
                }, null, 8, ["modelValue"]),
                (_ctx.fromError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.fromError), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_Datepicker, {
                  modelValue: _ctx.to,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.to) = $event)),
                  placeholder: "Távozás",
                  "enable-time-picker": false,
                  format: 'yyyy-MM-dd',
                  "auto-apply": ""
                }, null, 8, ["modelValue"]),
                (_ctx.toError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.toError), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.numberOfPeople,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.numberOfPeople) = $event)),
                  label: "Létszám",
                  variant: "outlined",
                  type: "number",
                  rules: [_ctx.rules.required, _ctx.rules.minOne]
                }, null, 8, ["modelValue", "rules"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: _ctx.placementType,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.placementType) = $event)),
                  items: _ctx.placementTypeOptions,
                  "item-title": "label",
                  "item-value": "value",
                  label: "Elhelyezés",
                  variant: "outlined",
                  rules: [_ctx.rules.required]
                }, null, 8, ["modelValue", "items", "rules"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.contactName,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.contactName) = $event)),
                  label: "Kapcsolattartó neve",
                  variant: "outlined",
                  rules: [_ctx.rules.required]
                }, null, 8, ["modelValue", "rules"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.contactPhone,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.contactPhone) = $event)),
                  label: "Kapcsolattartó telefonszáma",
                  variant: "outlined",
                  rules: [_ctx.rules.required]
                }, null, 8, ["modelValue", "rules"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_textarea, {
                  modelValue: _ctx.catering,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.catering) = $event)),
                  label: "Ellátás",
                  variant: "outlined",
                  rows: "2",
                  counter: _ctx.cateringMaxLength,
                  maxlength: _ctx.cateringMaxLength
                }, null, 8, ["modelValue", "counter", "maxlength"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.comment,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.comment) = $event)),
                  label: "Komment",
                  variant: "outlined"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                variant: "text",
                onClick: _ctx.closeDialog
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Mégse ")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_v_btn, {
                color: "primary",
                disabled: !_ctx.isFormValid || _ctx.submitting,
                loading: _ctx.submitting,
                onClick: _ctx.submit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.submitLabel), 1)
                ]),
                _: 1
              }, 8, ["disabled", "loading", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}